import React from "react";

import ChatContainer from "./ChatContainer";

export const ChatWindow: React.FC = () => {
	return <ChatContainer mode="floating" />;
};

export default ChatWindow;
